import React from 'react';
import NameLogo from '../images/NameLogo.png'

function Footer() {
    return (
       <footer className="w-full py-2 mt-auto flex items-center justify-center bg-transparent shrink-0">
            <div className="flex items-center gap-2 text-sm text-slate-500 font-medium">
                <img src={NameLogo} alt="Data Aces" className="h-3 w-auto object-contain" />
                <span>&copy; {new Date().getFullYear()}. All rights reserved.</span>
            </div>
        </footer> 
    )
}
    
export default Footer;
